import React, { ReactNode } from 'react';
import * as S from '../common.styles';

interface BaseTextFieldProps {
  children:ReactNode;
  error?: string;
  disabled?: boolean;
}

export const BaseTextField = ({
    children,
    error,
    disabled,
}: BaseTextFieldProps) => (
    <S.Wrapper disabled={disabled}>
        <S.Row error={error}>
            {children}
        </S.Row>
        <S.ErrorLabel>{error}</S.ErrorLabel>
    </S.Wrapper>
);
